export const Subscription = ({ fill, size = 48 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill={fill} height={size} width={size}><path d="M7 44q-1.2 0-2.1-.9Q4 42.2 4 41V19q0-1.2.9-2.1.9-.9 2.1-.9h34q1.2 0 2.1.9.9.9.9 2.1v22q0 1.2-.9 2.1-.9.9-2.1.9Zm0-3h34V19H7v22Zm13.35-3.55L31.4 30l-11.05-7.4ZM7.45 13v-3h33.1v3ZM14 7V4h20v3ZM7 41V19v22Z" /></svg>
    )
}

export const Library = ({ fill, size = 48 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill={fill} height={size} width={size}><path d="m21.2 29.35 13-8.35-13-8.35ZM13 38q-1.2 0-2.1-.9-.9-.9-.9-2.1V7q0-1.2.9-2.1.9-.9 2.1-.9h28q1.2 0 2.1.9.9.9.9 2.1v28q0 1.2-.9 2.1-.9.9-2.1.9Zm0-3h28V7H13v28Zm-6 9q-1.2 0-2.1-.9Q4 42.2 4 41V10h3v31h31v3Zm6-37v28V7Z" /></svg>
    )
}

export const Devbase = ({ fill, size = 48 }) => {
    return (
        <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080" fill={fill} height={size} width={size}>
            <path d="m1014 543l-285 288 138-288-144-294z" />
            <path d="m66 537l285-288-138 288 144 294z" />
            <path d="m611.9 128.5l-96.2 369.3 148.2-64.5-110.8 443.7 46.2-5-88.7 107.8-48.2-130 44.5 20.6 47.7-294.2-148.1 83.3 93.5-545.4z" />
        </svg>
    )
}